import { FormProvider } from 'react-hook-form';
import { useLegacyEditClient } from './hooks';
import {
  convertToClientFeatureFlagOptions,
  convertToCustomFieldDefinitions,
  convertToGroupOptions,
} from './logics';
import { LegacyEditClientPresentation } from './presentations';

type Props = {
  /** クライアントID */
  clientId: string;
};

/**
 * 利用企業編集フォームのコンテナコンポーネント（Legacy）
 * NOTE: Suspenseを使用するhookを含むため、親コンポーネントでSuspenseでラップしてください
 */
export const LegacyEditClient: React.FC<Props> = ({ clientId }) => {
  const {
    state: {
      methods,
      isButtonDisabled,
      clientName,
      clientIdNum,
      customFieldDefinitions,
      groups,
      clientData,
      partnerFeatureFlags,
    },
    actions: { handleOnSubmit },
  } = useLegacyEditClient({ clientId });

  return (
    <FormProvider {...methods}>
      <LegacyEditClientPresentation
        clientId={clientIdNum}
        clientName={clientName}
        isButtonDisabled={isButtonDisabled}
        groupOptions={convertToGroupOptions(groups)}
        customFieldDefinitions={convertToCustomFieldDefinitions(customFieldDefinitions)}
        clientFeatureFlagOptions={convertToClientFeatureFlagOptions(
          clientData,
          partnerFeatureFlags
        )}
        onSubmit={handleOnSubmit}
      />
    </FormProvider>
  );
};
